import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { OldSolutionsSection } from './components/OldSolutionsSection';
import { ProtocolSection } from './components/ProtocolSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { ForWhoSection } from './components/ForWhoSection';
import { PromiseAndCtaSection } from './components/PromiseAndCtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-cream overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <OldSolutionsSection data-id="element-3" />
      <ProtocolSection data-id="element-4" />
      <WhatYouGetSection data-id="element-5" />
      <ForWhoSection data-id="element-6" />
      <PromiseAndCtaSection data-id="element-7" />
      <Footer data-id="element-8" />
    </main>;
}